import { ArrowCounterclockwise20Regular, MoreHorizontal20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function AssistantMessageMenuTriggerActions({
  retryMenuId,
  retryOpen,
  handleOpenRetryMenu,
  menuId,
  menuOpen,
  handleOpenMenu,
}) {
  return (
    <>
      <Tooltip text="try again" placement="bottom">
        <button
          type="button"
          className={styles.actionButton}
          aria-label="Try again options"
          aria-controls={retryOpen ? retryMenuId : undefined}
          aria-haspopup="menu"
          aria-expanded={retryOpen ? 'true' : undefined}
          onClick={handleOpenRetryMenu}
        >
          <ArrowCounterclockwise20Regular />
        </button>
      </Tooltip>
      <Tooltip text="menu" placement="bottom">
        <button
          type="button"
          className={styles.actionButton}
          aria-label="Menu"
          aria-controls={menuOpen ? menuId : undefined}
          aria-haspopup="menu"
          aria-expanded={menuOpen ? 'true' : undefined}
          onClick={handleOpenMenu}
        >
          <MoreHorizontal20Regular />
        </button>
      </Tooltip>
    </>
  )
}
